import { render, staticRenderFns } from "./inventoryItem.vue?vue&type=template&id=5830b72e&"
import script from "./inventoryItem.vue?vue&type=script&lang=ts&"
export * from "./inventoryItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports